import { createSlice } from '@reduxjs/toolkit';
import {
    GET_PERFEED_FEEDBACKS_SUCCESS,
    changePageFeedbacks,
    GET_PERFEED_REQUESTS_SUCCESS,
    changePageRequests,
    saveSettingsSuccess,
    setRatingSettingsAction,
} from '../../actions/PerfeedActions';
import type { IUser } from '../../types';

const NAME = 'perfeed';

const mockFeedbackList = [
    {
        id: 1,
        name: 'Amelia Smith',
        project: 'meeting PM',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
    {
        id: 2,
        name: 'Emily Roberts',
        project: 'Project',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
    {
        id: 3,
        name: 'Emily Roberts',
        project: 'Sales meeting',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
];

const mockRequestList = [
    {
        id: 1,
        names: ['Amelia Smith'],
        project: 'meeting PM',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
    {
        id: 2,
        names: ['Emily Roberts', 'Amelia Smith', 'Evie Hall'],
        project: 'Project',
        date: '2019-07-18T14:20',
        status: 'edit',
        message: 'Please give me feedback, thanks',
    },
    {
        id: 3,
        names: ['Emily Roberts', 'Amelia Smith'],
        project: 'Sales meeting',
        date: '2019-07-18T14:20',
        status: 'edit',
        message: 'Please give me feedback, thanks',
    },
];

const initialPagination = {
    page: 0,
    pages: 0,
    totalElements: 0,
    start: 0,
    end: 0,
};

const initialRatingPoint = {
    link: 'https://survey.empfeed.com/perfeed/rating-point/list/361e5598433771440171284cb31d7cdc7de9af18',
    qr: '',
    list: [
        {
            id: 1,
            date: '2018-1-24T09:54',
            name: 'Meeting',
            message: 'Please give me feedback, thanks',
            subjects: [
                'kvalita',
                'odbornost',
                'komunikace',
                'prozákaznický přístup',
            ],
        },
        {
            id: 2,
            date: '2018-5-25T09:54',
            name: 'Meeting',
            subjects: [
                'kvalita',
                'odbornost',
                'komunikace',
                'prozákaznický přístup',
            ],
        },
    ],
};

export type PerfeedState = {
    feedbacks: {
        list: {
            items: typeof mockFeedbackList;
            pagination: typeof initialPagination;
        };
    };
    requests: {
        list: {
            items: typeof mockRequestList;
            pagination: typeof initialPagination;
        };
        settings: { email: number };
        ratingPoint: typeof initialRatingPoint;
    };
    rating: {
        settings: { user: IUser | null; subject: string; isAnonymous: boolean };
    };
};

const initialState: PerfeedState = {
    feedbacks: {
        list: { items: mockFeedbackList, pagination: initialPagination },
    },
    requests: {
        list: { items: mockRequestList, pagination: initialPagination },
        settings: { email: 1 },
        ratingPoint: initialRatingPoint,
    },
    rating: {
        settings: { user: null, subject: '', isAnonymous: false },
    },
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GET_PERFEED_FEEDBACKS_SUCCESS, (state) => {
                state.feedbacks.list.pagination = {
                    ...state.feedbacks.list.pagination,
                    pages: 10,
                    totalElements: 133,
                    start: state.feedbacks.list.pagination.page * 20,
                    end: state.feedbacks.list.pagination.page * 20 + 20,
                };
            })
            .addCase(changePageFeedbacks, (state, action) => {
                state.feedbacks.list.pagination = {
                    ...state.feedbacks.list.pagination,
                    page: action.payload,
                };
            })
            .addCase(GET_PERFEED_REQUESTS_SUCCESS, (state) => {
                state.requests.list.pagination = {
                    ...state.requests.list.pagination,
                    pages: 10,
                    totalElements: 133,
                    start: state.requests.list.pagination.page * 20,
                    end: state.requests.list.pagination.page * 20 + 20,
                };
            })
            .addCase(changePageRequests, (state, action) => {
                state.requests.list.pagination = {
                    ...state.requests.list.pagination,
                    page: action.payload,
                };
            })
            .addCase(saveSettingsSuccess, (state, action) => {
                state.requests.settings = action.payload;
            })
            .addCase(setRatingSettingsAction, (state, action) => {
                const payload = action.payload as
                    | {
                          user: IUser | null;
                          subject: string;
                          isAnonymous: boolean;
                      }
                    | typeof initialRatingPoint;
                if (
                    'user' in payload &&
                    'subject' in payload &&
                    'isAnonymous' in payload
                ) {
                    state.rating.settings = payload;
                } else if ('link' in payload && 'list' in payload) {
                    state.requests.ratingPoint =
                        payload as typeof initialRatingPoint;
                }
            });
    },
});

export default { reducer: slice.reducer, actions: slice.actions };
